import { Block, useBreakpoints } from "@stepapp/ui";

import { Grid } from "../../Grid";
import HourItem from "../HourItem";

type Props = {
  isDatePicked: boolean;
  selectHour: (hour: string) => void;
  hours: { hour: string; available: boolean }[];
  selectedHour: string;
  possibleHours: string[];
};

const HoursPicker = ({ hours, selectHour, isDatePicked, selectedHour }: Props) => {
  const { md } = useBreakpoints();
  const columns = md ? 6 : 4;

  return (
    <Grid columns={columns} gap={md ? 10 : 6}>
      {hours.map((item) => (
        <Block
          flex={1}
          key={item.hour}
          testID={item.available ? "availableHour" : "unavailableHour"}
        >
          <HourItem
            hour={item.hour}
            selectHour={selectHour}
            isDatePicked={isDatePicked}
            isAvailable={item.available}
            selectedHour={selectedHour}
          />
        </Block>
      ))}
    </Grid>
  );
};

export default HoursPicker;
